module.exports = __webpack_public_path__ + "static/img/logo.b89c7a57.png";